import { AddressDetails } from '@vend/business-components/dist/components/AddressForm/types'
import { detectCreditCard } from '@vend/credit-card-detector'
import { LineItem } from './line-item'

export interface FulfilmentDetail {
  type: FulfilmentType
  billingAddress?: AddressDetails
  shippingAddress?: AddressDetails
  note: string
  shouldAddNewAddress?: boolean
}

export enum FulfilmentType {
  UNSPECIFIED = 'UNSPECIFIED', // Explicitly set by the user when the fulfilment type is none, i.e. take now item
  DELIVERY = 'DISPATCH', // Explicitly set by the user when the fulfilment type is delivery
  PICKUP = 'PICKUP', // Explicitly set by the user when the fulfilment type is pickup
}

// This function is used to determine if the fulfilment type is set to delivery, pickup or none explicitly by the user
export type DefinedFulfilmentType = Extract<
  FulfilmentType,
  FulfilmentType.DELIVERY | FulfilmentType.PICKUP
>

export function isDefinedFulfilmentType(
  type?: FulfilmentType
): type is DefinedFulfilmentType {
  return type === FulfilmentType.DELIVERY || type === FulfilmentType.PICKUP
}

// This function is used to determine if ANY items in the sale have a fulfilment type set to delivery or pickup
export function hasDefinedFulfilmentType(lineItems: LineItem[]): boolean {
  return lineItems.some(lineItem =>
    isDefinedFulfilmentType(lineItem.fulfilmentType)
  )
}

export const NOTE_MAX_CHAR = 255
export function isNoteTooLong(note?: string): boolean {
  return (note || '').length > NOTE_MAX_CHAR
}

export function isNoteInvalid(note: string): boolean {
  return isNoteTooLong(note) || detectCreditCard(note)
}
